//@ts-nocheck
import { create } from "zustand";
import { persist } from 'zustand/middleware'


type TableStore = {
    items: {
        customers?: string[] | number[]
    },
    selectTableRows: (tableName: string, rows: any[]) => void
}

export const useTableStore = create<TableStore>(persist(
    (set) => ({
        items: {},
        _hasHydrated: false,

        selectTableRows: (tableName, rows) => set({
            items: {
                [tableName]: [...rows]
            }
        }),
        setHasHydrated: (state) => {
            set({
                _hasHydrated: state
            });
        }
    }),
    {
        onRehydrateStorage: (state) => {
            return () => state.setHasHydrated(true)
        },
        name: 'table-store'
    }
))
